let CreateActorError;
(function (CreateActorError) {
  CreateActorError["FetchRootKeyFailed"] = "FETCH_ROOT_KEY_FAILED";
  CreateActorError["CreateActorFailed"] = "CREATE_ACTOR_FAILED";
  CreateActorError["NotInitialized"] = "NOT_INITIALIZED";
  CreateActorError["LocalActorsNotSupported"] = "LOCAL_ACTORS_NOT_SUPPORTED";
})(CreateActorError || (CreateActorError = {}));
let ConnectError;
(function (ConnectError) {
  ConnectError["NotInitialized"] = "NOT_INITIALIZED";
  ConnectError["NotInstalled"] = "NOT_INSTALLED";
  ConnectError["ConnectFailed"] = "CONNECT_FAILED";
  ConnectError["IsLocked"] = "IS_LOCKED";
})(ConnectError || (ConnectError = {}));
let DisconnectError;
(function (DisconnectError) {
  DisconnectError["DisconnectFailed"] = "DISCONNECT_FAILED";
  DisconnectError["NotInitialized"] = "NOT_INITIALIZED";
})(DisconnectError || (DisconnectError = {}));
let InitError;
(function (InitError) {
  InitError["NotInstalled"] = "NOT_INSTALLED";
  InitError["InitFailed"] = "INIT_FAILED";
  InitError["FetchRootKeyFailed"] = "FETCH_ROOT_KEY_FAILED";
})(InitError || (InitError = {}));
let BalanceError;
(function (BalanceError) {
  BalanceError["NotInitialized"] = "NOT_INITIALIZED";
  BalanceError["QueryBalanceFailed"] = "QUERY_BALANCE_FAILED";
})(BalanceError || (BalanceError = {}));
let TokensError;
(function (TokensError) {
  TokensError["NotInitialized"] = "NOT_INITIALIZED";
  TokensError["QueryBalanceFailed"] = "QUERY_BALANCE_FAILED";
})(TokensError || (TokensError = {}));
let NFTsError;
(function (NFTsError) {
  NFTsError["NotInitialized"] = "NOT_INITIALIZED";
  NFTsError["QueryBalanceFailed"] = "QUERY_BALANCE_FAILED";
})(NFTsError || (NFTsError = {}));
let TransferError;
(function (TransferError) {
  TransferError["InsufficientBalance"] = "INSUFFICIENT_BALANCE";
  TransferError["TransferFailed"] = "TRANSFER_FAILED";
  TransferError["FaultyAddress"] = "FAULTY_ADDRESS";
  TransferError["NotInitialized"] = "NOT_INITIALIZED";
  TransferError["TokenNotSupported"] = "TOKEN_NOT_SUPPORTED";
  TransferError["NotConnected"] = "NOT_CONNECTED";
})(TransferError || (TransferError = {}));
let SignError;
(function (SignError) {
  SignError["NotConnected"] = "NOT_CONNECTED";
  SignError["NotInitialized"] = "NOT_INITIALIZED";
})(SignError || (SignError = {})); // type ProviderOptions = {
//   connector: IConnector,
// }

export { BalanceError as B, CreateActorError as C, DisconnectError as D, InitError as I, NFTsError as N, SignError as S, TransferError as T, ConnectError as a, TokensError as b };
